import React from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { H3 } from '../../../../layouts/TextStyles'
import { fakeSections } from '../../../../utils/constants'
import TopicProgressCard from './components/TopicProgressCard'
import { ui } from '../../../../utils/uiTokens'

const TopicsProgressPage = () => {
    const { formatMessage } = useIntl()

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>Физика</H3>
                    </Title>
                </Header>

                {/* {isFetching && <LinearProgress />} */}
                <TopicProgressCard sections={fakeSections} />
                <TopicProgressCard sections={fakeSections} />
                <TopicProgressCard sections={fakeSections} />
                <TopicProgressCard sections={fakeSections} />
            </Content>
        </Wrapper>
    )
}

export default TopicsProgressPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
